export default __webpack_public_path__ + "static/media/ic-call-us.6de1522a.svg";